import { render } from "./TermsPage.vue?vue&type=template&id=143b20e5&scoped=true&ts=true"
import script from "./TermsPage.vue?vue&type=script&lang=ts"
export * from "./TermsPage.vue?vue&type=script&lang=ts"

import "./TermsPage.vue?vue&type=style&index=0&id=143b20e5&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/end-vue_us_qa_azure_v24042026_02/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143b20e5"]])

export default __exports__